// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInPageLayoutStyles } from "@conklin/App/Widgets/Layout/SignInPageLayout";
import { Divider, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

signInPageLayoutStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        width: 100%;

        ${({ showAsColumns }: any) =>
            showAsColumns &&
            css`
                padding: 48px 20px 148px 20px;
                flex-direction: row;
                justify-content: center;

                ${xScreen("lte", "md")} {
                    padding: 0 0 148px;
                    .checkoutDivider {
                        width: 100%;
                        height: 1px;
                        margin: 32px 0;
                        flex: 0 0 100%;
                    }
                }

                ${xScreen("lte", "sm")} {
                    flex-direction: column;
                    padding: 0 0 32px;

                    ${Divider} {
                        width: 100%;
                        height: 1px;
                        margin: 32px 0;

                        &.checkoutDivider {
                            flex: none;
                        }
                    }
                }

                h3 {
                    font-size: 24px;
                    line-height: 29px;
                    margin-bottom: 16px;
                }
                [data-test-selector="signin-create-account"] h3 {
                    margin-bottom: 4px;
                }
            `}
    `,
};

signInPageLayoutStyles.signInSection = {
    css: css`
        flex: 1;
        max-width: 410px;
    `,
};

signInPageLayoutStyles.createAccountSection = {
    css: css`
        flex: 1;
        max-width: 410px;
    `,
};

signInPageLayoutStyles.guestCheckoutSection = {
    css: css`
        flex: 1;
        max-width: 410px;
        ${xScreen("lte", "md")} {
            flex: 0 0 100%;
            max-width: none;
        }
    `,
};
